import { createSlice } from '@reduxjs/toolkit';
import templateJsonStore from './TemplateJsonStore';
import { findElementById } from './TemplateJsonSlice';

const initialState = {
  id: null,
  item: null
};

const templateCopyItemSlice = createSlice({
  name: 'templateCopyItem',
  initialState,
  reducers: {
    selectCopyItem: (state, action) => {
      if (state.id === action.payload) return;

      state.id = action.payload
      if (state.id) {
        state.item = findElementById(templateJsonStore.getState().templateJson, state.id);
      } else {
        state.item = null;
      }
    },
    reSelectCopyItem: (state) => {
      if (state.id) {
        state.item = findElementById(templateJsonStore.getState().templateJson, state.id);
      }
    },
    deselectCopyItem: state => {
      state.id = null;
      state.item = null;
    }
  }
});

export const { selectCopyItem, deselectCopyItem, reSelectCopyItem } = templateCopyItemSlice.actions;
export default templateCopyItemSlice.reducer;
